import React from 'react';
import cn from 'clsx';

import Tooltip from '../../library/tooltip/tooltip';
import Typography from '../../library/typography/typography';

import { PRODUCT_GBB_CONTENT_QUERY } from './graphql/product-gbb-queries.js';

import { useQuery } from '../../shared/hooks/hooks';

import styles from './product-gbb.scss';

interface ProductGBBProps {
  className?: string;
  showGBBTooltip?: boolean;
  value?: string;
}

function ProductGBB(props: ProductGBBProps) {
  const { className, showGBBTooltip = false, value } = props;
  const { data, isLoading } = useQuery(PRODUCT_GBB_CONTENT_QUERY, {
    skip: !showGBBTooltip || !value
  });

  if (!value || isLoading) {
    return null;
  }

  const gbbLowerCase = value?.toLowerCase();

  const gbbTooltipContent = data?.recommendationQueries?.toolTips?.find(
    v => v.key === gbbLowerCase
  );

  return showGBBTooltip ? (
    <Tooltip
      content={gbbTooltipContent?.value}
      hoverOver
      render={
        <Typography
          className={cn(styles[gbbLowerCase], className)}
          size="extraSmall"
          tag="span"
        >
          {value}
        </Typography>
      }
    />
  ) : (
    <Typography
      className={cn(styles[gbbLowerCase], className)}
      size="extraSmall"
      tag="span"
    >
      {value}
    </Typography>
  );
}

export default ProductGBB;
